export const SHOW_LOADING = "SHOW_LOADING";
export const GET_NAME_SPACE = "GET_NAME_SPACE";
export const LOAD_NAME_SPACE = "LOAD_NAME_SPACE";
export const UPDATE_NAME_SPACE = "UPDATE_NAME_SPACE";
export const GET_TEMPLATES = "GET_TEMPLATES";
export const SAVE_TEMPLATE = "SAVE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const GET_BRAND_STYLE = "GET_BRAND_STYLE";
export const PUT_BRAND_STYLE = "PUT_BRAND_STYLE";
export const SAVE_BRAND_STYLE = "SAVE_BRAND_STYLE";
export const GET_WHATSAPP_ADMIN_NUMBERS = "GET_WHATSAPP_ADMIN_NUMBERS";
export const WHATSAPP_WARNING = "WHATSAPP_WARNING";
export const POST_WHATSAPP_ADMIN_NUMBERS = "POST_WHATSAPP_ADMIN_NUMBERS";
export const SAVE_WHATSAPP_ADMIN_NUMBERS = "SAVE_WHATSAPP_ADMIN_NUMBERS";
export const SYNC_TEMPLATES = "SYNC_TEMPLATES";
export const GET_CHANNEL_WHATSAPP_NUMBERS = "GET_CHANNEL_WHATSAPP_NUMBERS";
export const SAVE_CHANNEL_WHATSAPP_NUMBERS = "SAVE_CHANNEL_WHATSAPP_NUMBERS";
export const UPLOAD_PROFILE_PICTURE = "UPLOAD_PROFILE_PICTURE";
export const SEND_WHATSAPP_MESSENGER_SETTINGS = "SEND_WHATSAPP_MESSENGER_SETTINGS";
export const SAVE_WHATSAPP_MESSENGER_SETTINGS = "SAVE_WHATSAPP_MESSENGER_SETTINGS";
export const GET_WHATSAPP_MESSENGER_SETTINGS = "GET_WHATSAPP_MESSENGER_SETTINGS";
export const RESET_CHANNELS = "RESET_CHANNELS";
export const BRAND_STYLE_UPDATING = "BRAND_STYLE_UPDATING";
export const GET_WHATSAPP_NUMBER_METRICS = "GET_WHATSAPP_NUMBER_METRICS";
export const SAVE_WHATSAPP_NUMBER_METRICS = "SAVE_WHATSAPP_NUMBER_METRICS";
export const GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS = "GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS";
export const SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS = "SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS";
  
